import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Table,
  Alert,
  Form,
  Button,
} from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const AttendanceTransport = () => {
  const { userId, GetstudentData } = useContext(ProductContext);
  const studentId = GetstudentData?.id;
  const StudentSession = GetstudentData?.session;
  const authtoken = localStorage.getItem("token");

  const [attendanceData, setAttendanceData] = useState([]);
  const [transportDetails, setTransportDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!fromDate || !toDate || !studentId) return;

    setLoading(true);
    try {
      const attendanceRes = await fetch(
        // `https://api.mirai.healthcare/api/attendance/transportAttendance?student_id=${studentId}&from_date=${fromDate}&to_date=${toDate}`
        `https://api.mirai.healthcare/api/attendance/transportAttendance/transport-attendences-count?student_id=${studentId}&from_date=${fromDate}&to_date=${toDate}`,
        { headers: { "x-auth": authtoken } }
      );
      const attendanceJson = await attendanceRes.json();
      setAttendanceData(attendanceJson?.transport_attendance || []);
    } catch (err) {
      console.error("Error fetching attendance:", err);
    } finally {
      setLoading(false);
    }
  };


  const present = attendanceData?.present || 0;
const absent = attendanceData?.absent || 0;
const leave = attendanceData?.leave || 0;

const markedDays = present + absent + leave;

const attendancePercentage = markedDays
  ? ((present / markedDays) * 100).toFixed(2)
  : 0;


  return (
    <div className="page-wrapper">
      <Header />
      <Container className="mt-4">
        <Card className="mb-4 shadow-sm">
          <Card.Body>
            <h5>Select Date Range</h5>
            <Form onSubmit={handleSearch}>
              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group controlId="fromDate">
                    <Form.Label>From Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="toDate">
                    <Form.Label>To Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Button
                    variant="primary"
                    type="submit"
                    className="mt-3 w-100"
                  >
                    Search Attendance
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        
            <Row className="justify-content-center">
                                        <Col md={12}>
                                            <Card className="shadow-sm border rounded-3">
                                                <Card.Body>
                                                    <h5 className="fw-bold mb-4">Attendance Summary<span className="span_1" style={{float:'right'}}>
                                                      <Link to = "/attendancetransporthistory" className="btn btn-primary">History</Link></span></h5>
                                                    <div className="table-responsive">
                                                      
                                                        <table className="table table-bordered text-center">
                                                            <thead className="bg-primary text-white">
                                                                <tr>
                                                                    <th>Type</th>
                                                                    <th>Count</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="fw-bold text-success">Present</td>
                                                                    <td>{attendanceData?.present}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold text-danger">Absent</td>
                                                                    <td>{attendanceData?.absent}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold text-warning">Leave</td>
                                                                    <td>{attendanceData?.leave}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold text-secondary">Not Marked</td>
                                                                    <td>{attendanceData?.notMark}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold text-primary">Total Days</td>
                                                                    <td>{attendanceData?.totalDays}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold text-primary">Attendance Percentage</td>
<td className={attendancePercentage < 75 ? "text-danger" : "text-success"}>
  {attendancePercentage}%
</td>                                                                </tr>

                                                                
                                                            </tbody>
                                                        </table>
                                                      
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
{/* 
             <Card className="shadow-sm">
            //   <Card.Body>
            //     <h5 className="mb-3">🗓️ Attendance Records</h5>
            //     <Table responsive striped bordered hover>
            //       <thead>
            //         <tr>
            //           <th>Date</th>
            //           <th>Status</th>
            //           <th>In Time</th>
            //           <th>Out Time</th>
            //         </tr>
            //       </thead>
            //       <tbody>
            //         {attendanceData?.map((item) => (
            //           <tr key={item.id}>
            //             <td>{item.date}</td>
            //             <td
            //               className={
            //                 item.status === "present"
            //                   ? "text-success"
            //                   : "text-danger"
            //               }
            //             >
            //               {item.status.toUpperCase()}
            //             </td>
            //             <td>{item.in_time}</td>
            //             <td>{item.out_time}</td>
            //           </tr>
            //         ))}
            //       </tbody>
            //     </Table>
            //   </Card.Body>
            // </Card> */}
         
      </Container>
    </div>
  );
};

export default AttendanceTransport;
